import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const lymphNodeDisorder: AnswerPathTreeNode = {
  path: 'lymphNodeDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredLymphNodeDisorderDetails }],
};
